import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faLaptopCode, faGraduationCap } from "@fortawesome/free-solid-svg-icons";

const About = ({setActiveSection}) => {
  const [isAboutOpen, setIsAboutOpen] = useState(false);

  const handleAboutClick = () => {
    setIsAboutOpen(!isAboutOpen);
  };

  return (
    <section id="about">
      <div className="flex justify-center items-center min-h-screen">
        <div className={`bg-opacity-100 p-8 rounded-lg shadow-lg w-full md:w-[850px] card project-card ${isAboutOpen ? "active" : ""}`}>
          <h1 className="text-4xl md:text-6xl font-bold mb-2 md:mb-4">
            About Me
          </h1>
          <p className="text-md md:text-2xl text-white-800 mb-4 md:mb-6 font-bold running-text text-justify">
          I am a passionate software engineering student with a GPA of 4.0. 
          I am currently enrolled in a distance education program, but I am open to remote or relocation opportunities. 
          I have always been fascinated by problem-solving, and I believe that software engineering is the perfect career for me to use my skills to make a difference in the world.
          I am a self-motivated and details-oriented individual, and I am always eager to learn new things. 
          I am also a team player and I am always willing to help others. I dream of one day becoming a software architect,
          and I am confident that I have the skills and determination to achieve my goals.
          </p>
         
        <div className="flex justify-center space-x-6">
          <FontAwesomeIcon
             icon={faCode}
             className="text-2xl  wave-animation"  style={{color :' #c026d3'}}
           />
          <FontAwesomeIcon
             icon={faLaptopCode}
             className="text-2xl wave-animation"  style={{color :' #9333ea'}}
          />
          <FontAwesomeIcon
            icon={faGraduationCap}
             className="text-2xl wave-animation" style={{color :' #2563eb'}}
            />
        </div>
          <div className="mt-8 flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
          <button
             onClick={() => setActiveSection("home")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
              Go back to Home Page
              <span className="ml-2">
              <svg
  xmlns="http://www.w3.org/2000/svg"
  className="h-6 w-6 transform rotate-180"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M9 5l7 7-7 7"
  />
</svg>

              </span>
            </button>
            <button
             onClick={() => setActiveSection("projects")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
              Go to Skills Page
              <span className="ml-2">
              <svg
                 xmlns="http://www.w3.org/2000/svg"
                 className="h-6 w-6 transform "
                 fill="none"
                 viewBox="0 0 24 24"
                stroke="currentColor"
                    >
              <path
              strokeLinecap="round"
               strokeLinejoin="round"
               strokeWidth="2"
             d="M9 5l7 7-7 7"
             />
            </svg>

              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
